<template>
  <section class="title-detail__main">
    <div class="title-detail__main-item">
      <div class="title-detail__main-item-label">抬头类型</div>
      <div class="title-detail__main-item-radio">
        <div v-for="(item, index) in typeOptions" :key="index" v-model="invoiceInfo.titleType"
             class="title-detail__main-item-radio-check" @click="chooseTitleType(item.value)">
          <i :class="['icon', 'invoice_choose', invoiceInfo.titleType === item.value ? 'invoice_choose_on':'invoice_choose_off']"></i>
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
    <div v-if="invoiceInfo.titleType === 1" class="title-detail__main-item">
      <div class="title-detail__main-item-label">抬头名称<span>*</span></div>
      <input-item v-model="invoiceInfo.invoiceTitle" class="title-detail__main-item-input" placeholder="请填写抬头名称"
                  type="text"></input-item>
      <i v-if="isShow" :class="['icon', 'invoice_arrow_trans']" @click="gotoInvoiceTitle"></i>
    </div>
    <div v-else>
      <div class="title-detail__main-item">
        <div class="title-detail__main-item-label">公司名称<span>*</span></div>
        <input-item v-model="invoiceInfo.invoiceTitle" class="title-detail__main-item-input" placeholder="请填写公司名称"
                    type="text"></input-item>
        <i v-if="isShow" :class="['icon', 'invoice_arrow_trans']" @click="gotoInvoiceTitle"></i>
      </div>
      <div class="title-detail__main-item">
        <div class="title-detail__main-item-label">公司税号<span>*</span></div>
        <input-item v-model="invoiceInfo.taxpayer" class="title-detail__main-item-input" placeholder="请填写纳税人识别号"
                    type="text"></input-item>
        <i v-if="isShow" :class="['icon', 'invoice_arrow_trans']" @click="gotoInvoiceTitle"></i>
      </div>
      <div class="title-detail__main-item">
        <div class="title-detail__main-item-label">注册地址</div>
        <input-item v-model="invoiceInfo.address" class="title-detail__main-item-input" placeholder="请填写公司注册地址"
                    type="text"></input-item>
      </div>
      <div class="title-detail__main-item">
        <div class="title-detail__main-item-label">注册电话</div>
        <input-item v-model="invoiceInfo.phone" class="title-detail__main-item-input" placeholder="请填写公司注册电话"
                    type="text"></input-item>
      </div>
      <div class="title-detail__main-item">
        <div class="title-detail__main-item-label">开户银行</div>
        <input-item v-model="invoiceInfo.bankName" class="title-detail__main-item-input" placeholder="请填写公司开户银行"
                    type="text"></input-item>
      </div>
      <div class="title-detail__main-item">
        <div class="title-detail__main-item-label">银行账号</div>
        <input-item v-model="invoiceInfo.bankAccount" class="title-detail__main-item-input" placeholder="请填写公司银行账号"
                    type="text"></input-item>
      </div>
    </div>
  </section>
</template>

<script>
import InputItem from 'components/common/InputItem';

export default {
  components: {
    InputItem,
  },
  name: 'index',
  props: {
    invoiceInfo: {},
    isShow: true,
    from: '',
  },
  data() {
    return {
      typeOptions: [
        { label: '企业单位', value: 0 },
        { label: '个人/非企业单位', value: 1 },
      ],
    };
  },
  methods: {
    chooseTitleType(type) {
      this.invoiceInfo.titleType = type;
    },
    gotoInvoiceTitle() {
      if (this.from) {
        this.$router.push({ path: '/invoice/title', query: { from: this.from } });
      } else {
        this.$router.push({ path: '/invoice/title' });
      }
    },
  },

};
</script>

<style lang="scss">

.title-detail {
  &__main {
    &-wrap {
      height: 100%;

      section {
        margin-top: 20px;
        padding: 0 30px;
        background: #fff;
      }
    }

    &-item {
      min-height: 96px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      font-size: 28px;
      justify-content: space-between;

      &-label {
        /*margin-right: 46px;*/
        width: 127px;
        font-size: 28px;
        font-family: PingFangSC;
        color: rgba(50, 50, 50, 1);
        line-height: 40px;

        span {
          color: #FF5F00;
        }
      }

      &-info {
        flex: 1;
        margin-left: 40px;
        font-size: 28px;
        color: #323232;
        display: flex;
        align-items: center;

        span {
          width: 450px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: keep-all;
          margin-right: 40px;
        }
      }


      &-input {
        flex: 1;
        margin-left: 40px;
      }

      &-radio {
        flex: 1;
        margin-left: 40px;
        display: flex;
        flex-direction: row;

        &-check {
          margin-right: 50px;
          display: flex;
          align-content: center;
        }

        span {
          margin-left: 8px;
          color: #323232;
          font-size: 28px !important;
        }
      }

      .invoice_choose {
        width: 34px !important;
        height: 34px !important;
      }

      input {
        font-size: 28px;
        color: #323232;
      }

      :last-child {
        border: none;
      }
    }
  }
}

</style>
